module.exports = __webpack_public_path__ + "img/bg.a553d685.svg";